import React from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import {ReactComponent as Logo } from "../../assets/icons/logo.svg"

const Header = ({ setUser }) => {
  const navigate = useNavigate();
  const location = useLocation();
  // 저장값이 깨져 있으면 렌더 도중 예외가 나 화면 전체가 백지가 된다. App.js와 같은 방식으로 막는다.
  const user = (() => {
    try {
      const storedUser = localStorage.getItem("user");
      return storedUser ? JSON.parse(storedUser) : null; // null 가능성 허용
    } catch (error) {
      return null;
    }
  })();
  const isAdmin = user?.user?.role === "admin"; // 안전한 접근
  const userName = user?.user?.name || "";
  // 로그인/회원가입 화면에서는 로그인 상태 UI를 그리지 않는다.
  // 로그인 직후 매장 조회를 기다리는 동안 이 화면에 머무는데, 그때 관리자 버튼이
  // 잠깐 나타났다 사라지는 깜빡임이 생기기 때문이다.
  const isAuthPage = location.pathname === "/login" || location.pathname === "/signup";
  const isLoggedIn = !!user && !isAuthPage;
  
  const handleLogout = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    localStorage.removeItem("selected_store_id");
    setUser(null);
    navigate("/", { replace: true }); // 로그아웃 후 메인페이지 이동
  };

  return (
    <header className="w-full left-0 top-0 px-4 md:px-[160px] lg:px-[200px] md:py-6">
      <div className="w-full bg-white flex justify-between items-center ">
        <Link to="/" className="text-xl font-bold"><Logo className="ml-1 w-[90px] md:w-[120px]"/></Link>
        <div className="flex items-center gap-4">
          {isLoggedIn ? (
            isAdmin ? (
              <Link to="/admin" className="px-4 py-2 text-sm bg-gray-900 text-white rounded-2xl">관리자 화면</Link>
            ) : (
              <Link to="/mypage" className="flex items-center">
                <div className="w-10 h-10 bg-gray-300 text-white flex items-center justify-center rounded-full text-sm">
                  {userName.slice(-2)}
                </div>
              </Link>
            )
          ) : location.pathname === "/login" ? (
            <Link to="/signup" className="px-4 py-2 border border-gray-900 text-gray-900 rounded-2xl hover:bg-gray-900 hover:text-white">
              회원가입
            </Link>
          ) : location.pathname === "/signup" ? (
            <Link to="/login" className="px-4 py-2 bg-gray-900 text-white rounded-2xl">
              로그인
            </Link>
          ) : (
            <Link to="/login" className="px-4 py-2 bg-gray-900 text-white rounded-2xl">
              로그인
            </Link>
          )}
          {isLoggedIn && (
            <button onClick={handleLogout} className="px-4 py-2 text-sm border border-gray-900 text-gray-900 rounded-2xl hover:bg-gray-900 hover:text-white">
              로그아웃
            </button>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;